module.exports = __webpack_public_path__ + "static/Roboto-Medium-d08840599e05db7345652d3d417574a9.ttf";